<template>
  <div class="m-login__signin flipInX animated">
    <div class="m-login__form m-form mt-4 px-3">
      <div class="m-login__head">
        <h3 class="m-login__title">{{ header }}</h3>
        <p class="m-login__welcome text-center">{{ subheader }}</p>
      </div>
      <login-alert/>
      <div class="m-login__form-action mt-5 mb-4">
        <div v-if="selfRegistration">
          <button class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls btn-block"
                  @click="setSignUpForm">
            Zarejestruj się przez e-mail
          </button>
          <p class="mt-3">
            Masz już konto? <a class="m-link m-link--state m-link--ls"
                               @click="setSignInForm">Zaloguj się</a>
          </p>
        </div>
        <button v-else
                class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls btn-block"
                @click="setSignInForm">
          Zaloguj się przez e-mail
        </button>
      </div>
      <separator>lub</separator>
      <social-sign-in-button v-if="isGoogleLoginEnabled" variant="google" class="my-4"></social-sign-in-button>
      <social-sign-in-button v-if="isFacebookLoginEnabled" variant="facebook" class="my-4"></social-sign-in-button>
      <social-sign-in-button v-if="isAppleLoginEnabled" variant="apple" class="my-4"></social-sign-in-button>
      <social-sign-in-button v-if="isAppleV2LoginEnabled" variant="apple2" class="my-4"></social-sign-in-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Separator from "@/components/login/Separator";
import SocialSignInButton from "@/components/login/SocialSignInButton";
import LoginAlert from "@/components/login/LoginAlert";
import ExternalLogin from "@/mixins/externalLogin";

export default {
  name: "SelectLogin",
  components: {LoginAlert, SocialSignInButton, Separator},
  mixins: [ExternalLogin],
  destroyed() {
    this.clearLoginInfo();
    this.clearLoginError();
  },
  methods: {
    ...mapActions([
      'setSignInForm',
      'setSignUpForm',
      'clearLoginInfo',
      'clearLoginError',
    ]),
  },
  computed: {
    ...mapState({
      header: state => state.settings.login.header,
      subheader: state => state.settings.login.subheader,
      selfRegistration: state => parseInt(state.settings.selfRegistration),
    })
  },
}
</script>

<style scoped>
.m-link {
  color: rgb(113, 106, 202) !important;
  cursor: pointer;
}

.m-link.m-link--ls {
  color: var(--accent-color) !important;
}

.m-link.m-link--ls:hover::after {
  border-bottom: 1px solid var(--accent-color);
  opacity: .3;
}
</style>
